/*
 * @Author: your name
 * @Date: 2021-11-25 14:45:37
 * @LastEditTime: 2021-11-25 15:17:10
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \team-web\src\api\apiIndividualRecord.js
 */
/**
 * @name 个人、班组记账接口列表
 * @time 2021-11-25 11:24:52
 */
import request from '@/http'

export const api = {
  settleBillAdd: (data) => request.post(`/settleBill/add`, data), // 增加/编辑 记账
  settleBillTeamAdd: (data) => request.post(`/settleBill/team/income`, data), // 班组记账-记收/支v2.1.5
  settleBillTeamList: (data) => request.post(`/settleBill/team/list`, data), // 班组记账列表v2.1.5
  defaultProject: (data) => request.post(`/settleProject/defaultProject`,data), // 班组记账默认项目v2.1.5
  getProjectPage: (data) => request.post(`/settleProject/getProjectPage`,data),// 获取项目列表
  settleBillDetail: (no) => request.get(`/settleBill/detail/${no}`), // 获取记账详情信息
  getsettleBilllist: (data) => request.post(`/settleBill/list`, data),//获取记账列表数据
  deleteBill:(no) => request.get(`/settleBill/delete/${no}`),//删除记账数据
  addTenderMoney: (data) => request.post(`/settleProject/add`,data),// 记工项目添加
}